import { getDomainUrl } from 'core/utils';

export const customerOrderListPath = () => '/order/customer/list';
export const vendorOrderListPath = () => '/order/vendor/list';

export const orderPartsPath = (quoteId: number | string = ':quoteId') => `/order/${quoteId}/parts`;

export const oldOrdersPath = () => `${getDomainUrl()}/order/list`;
export const oldOrderPath = (orderId: string) =>
  `${getDomainUrl()}/order/part/list?order=${orderId}`;
